import initialState from './initialState';
import { ActionType } from './action';

function aboutReducer(state = initialState, action = {}) {
  switch (action.type) {
    case ActionType.RECEIVE_ABOUT:
      return {
        ...state,
        about: action.payload.about,
      };
    case ActionType.SET_IS_LOADING_ABOUT:
      return {
        ...state,
        isLoading: action.payload.isLoading,
      };
    case ActionType.SET_IS_ERROR_ABOUT:
      return {
        ...state,
        isError: action.payload.isError,
      };
    default:
      return state;
  }
}

export default aboutReducer;
